import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id FE06C355-A6BB-464A-9B7D-B07CE7D551FC
 * name razor-single-edge
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/razor-single-edge.svg
 * tags
 * - Hardware / Tools 
 */
export const RazorSingleEdgeIcon = createSvgIcon(<><path d="M22 5V8H2V5H22M22 13V18H2V13H3.5C4.33 13 5 12.33 5 11.5S4.33 10 3.5 10L2 10V9H22V10H20.5C19.67 10 19 10.67 19 11.5S19.67 13 20.5 13H22M13 11C13 10.45 12.55 10 12 10S11 10.45 11 11V13C11 13.55 11.45 14 12 14S13 13.55 13 13V11Z" /></>, 'RazorSingleEdgeIcon');
export default RazorSingleEdgeIcon